import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';

jQuery(function($) {

    // Init .wpcf7-select elements
    $('.wpcf7-select').each(function () {
        if (!$(this).hasClass('choices-initialized')) {
            new Choices(this, {
                searchEnabled: false,
                itemSelectText: '',
                shouldSort: false,
                removeItemButton: false
            });
            $(this).addClass('choices-initialized');
        }
    });
    
});
